import axios from 'axios';

// export const API_URL_SERVER = 'http://localhost:5002/api'; // Remove or comment this out

export const API_URL_SERVER = 'https://www.trading897.co/api'; // Your server's public IP

export const getStatus = () =>
    fetch(`${API_URL_SERVER}/status`).then(res => res.json());

export const startTrading = () =>
    fetch(`${API_URL_SERVER}/start`, { method: 'POST' }).then(res => res.json());

export const stopTrading = () =>
    fetch(`${API_URL_SERVER}/stop`, { method: 'POST' }).then(res => res.json());

export const exitPosition = (accountId) =>
    fetch(`${API_URL_SERVER}/exit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(accountId ? { account_id: accountId } : {}),
    }).then(res => res.json());

export const updateParams = (params) => fetch(`${API_URL_SERVER}/update_params`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
}).then(res => res.json());

export const addAccount = (account) =>
    fetch(`${API_URL_SERVER}/accounts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(account),
    }).then(res => res.json());


export const fetchPnL = async (accountId) => {
    const response = await fetch(`${API_URL_SERVER}/pnl/${accountId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error('Failed to fetch PnL');
    return await response.json();
};

export const getStrategyConfigs = () => {
    return axios.get(`${API_URL_SERVER}/strategy-configs`);
};

export const updateStrategyConfig = (strategyName, config) => {
    return axios.put(`${API_URL_SERVER}/strategy-config/${strategyName}`, { config });
};